import { useState, createContext, useContext } from "react";

import { Snackbar, Alert } from "@mui/material";

export const ExplorerLayoutContext = createContext();

export const ExplorerLayoutContextProvider = ({ children }) => {
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarProps, setSnackbarProps] = useState({});

  const activateSnackbar = (props) => {
    setSnackbarProps(props);
    setSnackbarOpen(true);
    setTimeout(() => setSnackbarOpen(false), 5000);
  };

  const handleClose = () => setSnackbarOpen(false);

  return (
    <ExplorerLayoutContext.Provider
      value={{
        snackbarOpen,
        setSnackbarOpen,
        snackbarProps,
        activateSnackbar
      }}
    >
      {children}
      <Snackbar
        open={snackbarOpen}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        onClose={handleClose}
      >
        <Alert
          severity={snackbarProps.severity || "info"}
          variant="filled"
          onClose={handleClose}
        >
          {snackbarProps.message}
        </Alert>
      </Snackbar>
    </ExplorerLayoutContext.Provider>
  );
};

const useExplorerLayoutContext = () => useContext(ExplorerLayoutContext);
export default useExplorerLayoutContext;
